export default "__VITE_ASSET__VnL6Zcnj__"